module.exports = __webpack_public_path__ + "img/tools_legislation1.1383b6df.png";